const VideosSchema = () => ({
  title: 'AgSUS Lista de vídeos',
  fieldsets: [
    {
      id: 'default',
      title: 'Vídeos',
      fields: [
        'videos',
        'fundo',
        'etiqueta',
        'contagem',
        'titulo',
        'nivel',
        'subtitulo',
      ],
    },
  ],
  properties: {
    videos: {
      title: 'Vídeos',
      description:
        'Cole o endereço do vídeo no YouTube; o título vem sozinho e pode ser trocado.',
      widget: 'object_list',
      schema: {
        title: 'Vídeo',
        fieldsets: [
          { id: 'default', title: 'Default', fields: ['url', 'titulo'] },
        ],
        properties: {
          url: {
            title: 'Endereço no YouTube',
            description: 'Ex.: https://www.youtube.com/watch?v=…',
          },
          titulo: { title: 'Título' },
        },
        required: [],
      },
    },
    fundo: {
      title: 'Fundo',
      choices: [
        ['branco', 'Cartão branco, na coluna do texto'],
        ['azul', 'Faixa azul, com a lista ao lado do player'],
      ],
      default: 'branco',
      noValueOption: false,
    },
    etiqueta: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta. Ex.: Vídeos',
      default: 'Vídeos',
    },
    contagem: {
      title: 'Número de vídeos na etiqueta',
      type: 'boolean',
      default: true,
    },
    titulo: { title: 'Título', description: 'Opcional.' },
    nivel: {
      title: 'Nível do título',
      choices: [
        ['h2', 'Intertítulo (H2)'],
        ['h3', 'Subtítulo (H3)'],
      ],
      default: 'h2',
      noValueOption: false,
    },
    subtitulo: { title: 'Texto sob o título', widget: 'textarea' },
  },
  required: [],
});

export default VideosSchema;
